import getECommercePageCounts from 'editor/src/store/variants/selector/getECommercePageCounts';

import { RootState } from 'editor/src/store';

import getSpreadCountForIncrement from '../util/getSpreadCountForIncrement';

// How many pages a single add / duplicate / remove-pages click changes for the
// given spread — the number to show in the page-menu labels instead of a
// hardcoded value. The add/remove operations move one grid step's worth of
// spreads (getSpreadCountForIncrement), each holding this spread's pages, so the
// page delta is spreads-per-step × pages-per-spread. Returns 0 when there is no
// design.
function getPagesPerStep(state: RootState, spreadIndex: number): number {
  const { designData } = state.design;
  if (!designData) {
    return 0;
  }

  const spreadsPerStep = getSpreadCountForIncrement(designData, spreadIndex, getECommercePageCounts(state));
  const pagesPerSpread = designData.spreads[spreadIndex]?.pages.length || 1;
  return spreadsPerStep * pagesPerSpread;
}

export default getPagesPerStep;
